<template>
  <div class="gmaps gmaps-1-3">
    <div ref="map" class="map"></div>
  </div>
</template>

<script>
  import loadGoogleMapsAPI from 'load-google-maps-api'

  const GOOGLE_MAPS_API_KEY = process.env.GMAPS_API_KEY

  export default {
    props: {
    },

    data () {
      return {
        map: null,
        mapsApi: null,
      }
    },

    methods: {
      setupMap () {
        const latLng = new google.maps.LatLng(48.146481, 17.103202) // Sladkovicova was 48.149996, 17.106038
        this.map = new google.maps.Map(this.$refs.map, {
          center: latLng,
          zoom: 19,
          scrollwheel: false,
          styles: [
            {"featureType":"water","elementType":"all","stylers":[{"hue":"#bbbbbb"},{"saturation":-100},{"lightness":-4},{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#999999"},{"saturation":-100},{"lightness":-33},{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"hue":"#999999"},{"saturation":-100},{"lightness":-6},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#aaaaaa"},{"saturation":-100},{"lightness":-15},{"visibility":"on"}]}
          ],
        })

        new google.maps.Marker({
          position: latLng,
          map: this.map,
          title: 'Hello World!'
        })
      }
    },

    mounted () {
      if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {
        loadGoogleMapsAPI({ key: GOOGLE_MAPS_API_KEY }).then((mapsApi) => {
          this.setupMap()
        })
      } else {
        this.setupMap()
      }
    },
  }
</script>

<style scoped>
  .price {
    color: #fdc900;
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue?5d584995